import { Alert } from './types';

export const UNCONFIRMED_EMAIL: Alert = {
  alertIcon: 'envelope',
  description: 'For added security, please verify your email address.',
  navigateTo: 'inboxVerifyEmailAlert',
  title: 'Unverified Email',
  type: 'UNCONFIRMED_EMAIL',
};
export const UNACCEPTED_TERMS: Alert = {
  alertIcon: 'triangle-exclamation',
  description: 'You must accept the terms and conditions to enable trading in your account',
  navigateTo: 'inboxDwollaAlert',
  title: 'Terms and Conditions',
  type: 'UNACCEPTED_TERMS',
};
export const UNACCEPTED_AGREEMENT: Alert = {
  alertIcon: 'triangle-exclamation',
  description: 'You must accept the Advisory Agreement to enable Goals for your account',
  navigateTo: 'inboxAgreementAlert',
  title: 'Advisory Agreement',
  type: 'UNACCEPTED_AGREEMENT',
};

// TODO: Implement these alerts later

// export const REVIEW_SUITABILITY: Alert = {
//   alertIcon: 'address-card',
//   description: 'Some of your account information requires an annual review.',
//   navigateTo: 'InvestorProfileOptions',
//   title: 'Review Suitability',
//   type: 'REVIEW_SUITABILITY',
// };

// export const UPLOAD_PHOTO_ID: Alert = {
//   alertIcon: 'exclamation-triangle',
//   description: 'For added security, please upload a copy of a government-issued photo identification.',
//   navigateTo: 'UploadID',
//   title: 'Upload Photo I.D.',
//   type: 'UPLOAD_PHOTO_ID',
// };
